/**
 * The planning context slot is authoritative for both Browse evaluation and
 * saving. A recipe's native category is only the free-Browse save fallback.
 */
export function targetMealTypeForBrowse(contextMealType, isSwapMode) {
  if (isSwapMode) return null; // the outgoing saved row remains Swap authority
  return contextMealType || null;
}

export function mealTypeForBrowseSave(contextMealType, nativeCategory) {
  return contextMealType || nativeCategory;
}
